import React, { createContext, useState, useContext } from 'react';

const AppStateContext = createContext();

export const useAppState = () => useContext(AppStateContext);

export const AppStateProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  return (
    <AppStateContext.Provider value={{ isLoading, setIsLoading, error, setError }}>
      {children}
    </AppStateContext.Provider>
  );
};